import Image from "next/image";
import AppMockup from "./AppMockup";

export default function Hero() {
  return (
    <section className="relative pt-32 pb-20 md:pb-32 overflow-hidden bg-[#fdfaf2] dark:bg-[#111111] transition-colors duration-300">
      {/* Background Elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute -top-[20%] -right-[10%] w-[70%] h-[70%] bg-[#C9A227]/5 rounded-full blur-[120px]"></div>
        <div className="absolute top-[20%] -left-[10%] w-[50%] h-[50%] bg-blue-500/5 rounded-full blur-[100px]"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center relative z-10">
        <div className="text-center lg:text-left">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-[#1a1a1a] dark:text-white leading-[1.1] mb-8 tracking-tight">
            One-Stop <br />
            Shop for <span className="text-[#6b5a1a] dark:text-[#C9A227]">Precious Metals</span>
          </h1>
          <p className="text-xl text-gray-600 dark:text-gray-400 mb-10 max-w-lg mx-auto lg:mx-0 leading-relaxed">
          Manage and run real-time metal procurement for your jewellery business through a secure, integrated platform.
          </p>

          <div className="flex flex-wrap justify-center lg:justify-start gap-4">
            <button
              type="button"
              className="flex items-center gap-4 bg-[#1a1a1a] dark:bg-white dark:text-black text-white px-6 py-3 rounded-2xl hover:scale-[1.02] transition-transform shadow-xl shadow-black/5"
            >
              <div className="w-10 h-10 rounded-full bg-white/10 dark:bg-black/10 flex items-center justify-center p-2">
                <Image
                  src="/appstore.svg"
                  alt="App Store"
                  width={24}
                  height={24}
                  className="brightness-0 invert dark:invert-0"
                />
              </div>
              <div className="text-left">
                <div className="text-[10px] uppercase font-medium tracking-widest opacity-70">Coming soon on</div>
                <div className="text-lg font-bold leading-none">App Store</div>
              </div>
            </button>
            <button
              type="button"
              className="flex items-center gap-4 bg-[#1a1a1a] dark:bg-white dark:text-black text-white px-6 py-3 rounded-2xl hover:scale-[1.02] transition-transform shadow-xl shadow-black/5"
            >
              <div className="w-10 h-10 rounded-full bg-white/10 dark:bg-black/10 flex items-center justify-center p-2">
                <Image
                  src="/playstore.svg"
                  alt="Google Play"
                  width={24}
                  height={24}
                  className="brightness-0 invert dark:invert-0"
                />
              </div>
              <div className="text-left">
                <div className="text-[10px] uppercase font-medium tracking-widest opacity-70">Coming soon on</div>
                <div className="text-lg font-bold leading-none">Google Play</div>
              </div>
            </button>
          </div>
        </div>

        <div className="relative flex justify-center lg:justify-end mt-12 lg:mt-0">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-gradient-to-tr from-[#C9A227]/20 to-transparent blur-[60px] rounded-full -z-10"></div>
          <AppMockup />
        </div>
      </div>
    </section>
  );
}
